"use client";

import { ShoppingBag } from "@ellaandil/ui";
import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";
import { useCart } from "@/features/cart";

export interface HeaderCartProps extends ComponentProps<"div"> {
	countClassName?: string;
}

export const HeaderCart = ({ className, countClassName, ...props }: HeaderCartProps) => {
	const { data } = useCart();
	const count = data?.count ?? 0;

	return (
		<div
			className={clsx(
				"relative inline-flex min-h-9 min-w-9 cursor-pointer items-center justify-center p-1.5 text-text-dark-text-1",
				className,
			)}
			{...props}
		>
			<ShoppingBag className="size-6" />
			{count > 0 && (
				<span
					className={twMerge(
						"-top-0.5 -right-0.5 absolute flex size-4 items-center justify-center rounded-full bg-background-bg-dark font-body font-normal text-2xs leading-none tabular-nums lining-nums text-text-light-text-1",
						countClassName,
					)}
				>
					{count}
				</span>
			)}
		</div>
	);
};
